import { notifyAdapter } from '@/features/messages/adapters/notify-adapter'
import { pbWorkItems } from './adapters/pb-work-items'
import { pbWorkflows } from './adapters/pb-workflows'
import { pbCustomerLookup } from './adapters/pb-customer-lookup'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { CustomerLookupPort, WorkflowPort, WorkItemPort } from './domain/workflow'

const workflows: WorkflowPort = pbWorkflows
const workItems: WorkItemPort = pbWorkItems
const customerLookup: CustomerLookupPort = pbCustomerLookup
const notify: NotifyPort = notifyAdapter

export { workflows, workItems, customerLookup, notify }
